import {
  IconAngleRight,
  IconBell,
  IconCheckSquare,
  IconEnvelopeAlt,
} from '@maia/icons';
import { Button, InfoCard, PageHeader, StaticNotification } from '@maia/ui';
import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/add-insurance/$customer/insurance-send',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { customer } = Route.useParams();
  return (
    <div className="layout-sidebar">
      <PageHeader
        title="De verzekeringsorder is verstuurd"
        description="Er gebeuren allemaal slimme dingen"
        className="area-page-header"
      />

      <div className="area-page-content content-grid">
        <StaticNotification
          variant="info"
          size="small"
          className="col-span-full"
        >
          <span className="font-medium">Belangrijk!</span> De verzekering is in
          aanvraag en moet nog wel afgerond worden door de klant
        </StaticNotification>

        <ul className="space-y-12 col-span-full">
          <li>
            <InfoCard
              icon={IconEnvelopeAlt}
              title="Afrondingsemail"
              description="Binnen enkele minuten ontvangt de klant een email waarmee hij/zij de bestelling kan afronden"
            />
          </li>
          <li>
            <InfoCard
              icon={IconBell}
              title="Automatische Herinneringen"
              description="Er worden automatische herinneringen gestuurd bij het niet afronden van de offerte."
            />
          </li>
          <li>
            <InfoCard
              icon={IconCheckSquare}
              title="Taakcreatie bij afwijzing"
              description="Bij afwijzing wordt er een taak aangemaakt voor de broker"
            />
          </li>
        </ul>

        <div className="col-span-full flex justify-end">
          {/* // TODO: Add link to customer */}
          <Link to="/customers/$guid" params={{ guid: customer }}>
            <Button intent="primary" iconRight={IconAngleRight}>
              Terug naar klant
            </Button>
          </Link>
        </div>
      </div>

      <div className="area-page-sidebar invisible"></div>
    </div>
  );
}
